import React, { Component } from 'react';
import clipboard from 'clipboard';
import './App.css';
class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			pic_left: {
				url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				caption: 'Описание',
				style: {
					float: 'none',
					margin: 0,
					left: 0
				}
			},
			pic_right: {
				url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				caption: 'Описание',
				style: {
					float: 'none',
					margin: 0,
					left: 0
				}
			},
			pic_regular: {
				url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				spoiler: false,
				caption: 'Описание',
				style: {
				}
			},
			pic_big: {
				url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				caption: 'Описание',
				spoiler: false,
				style: {
					width: '484px',
					margin: 0
				}
			},
			pic_full: {
				url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				caption: 'Описание',
				spoiler: false,
				style: {
					width: '484px',
					margin: 0
				}
			},
			quote_left: {
				text: 'Текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст.',
				title: 'Заголовок',
				footer: 'Подпись подпись',
				style: {
					margin: 0,
					left: 0,
					right: 0,
					float: 'none'
				}
			},
			quote_right: {
				text: 'Текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст.',
				title: 'Заголовок',
				footer: 'Подпись подпись',
				style: {
					margin: 0,
					left: 0,
					right: 0,
					float: 'none'
				}
			},
			direct_quote: {
				photo: 'https://manutd.one/uploads/posts/2020-09/1601212124_xyuiraesjdk.jpg',
				author: 'Донни ван де Бек',
				title: 'Щас скажу',
				text: 'Говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю.',
				style: {
					margin: 0
				}
			},
			quote: {
				author: 'Донни ван де Бек',
				title: 'Щас скажу',
				text: 'Говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю говорю.',
				style: {
					margin: 0,
					width: '70%',
					marginLeft: '13%'
				}
			},
			similar_article: {
				url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				img_url: 'https://manutd.one/uploads/posts/2020-09/1601210020_img_9408.jpg',
				title: 'Заголовок новой статьи.',
				subtitle: 'Читайте также',
				description: 'Вот такая есть у нас статья замечательная, читайте пожалуйста.',
				style: {
				}
			},
			articles_navigate: {
				url1: '',
				title1: 'Статья номер раз',
				description1: 'Есть у нас статья номер раз, там очень интересный текст.',
				url2: '',
				title2: 'Статья номер два',
				description2: 'Есть у нас статья номер два, там очень интересный текст.'
			}
		}
	}

	componentDidMount() {
		new clipboard('button');
	}

	copyToClipboard(html) {
		console.log('copy', html);
	}

	handleChange(params, event) {
		let newState = this.state;

		let value = event.target.value.replace(/(?:\\[rn]|[\r\n]+)+/g, "<br>");

		if (params.field === 'spoiler') {
			value = event.target.checked;
		}
		newState[params.type][params.field] = value;

		this.templates = {
			pic_regular: `<figure class="articleFigure ${this.state.pic_regular.spoiler ? 'articleFigure--spoiler' : ''}">
				<img src="${this.state.pic_regular.url}" alt="${this.state.pic_regular.caption}" />
				<figcaption>${this.state.pic_regular.caption}</figcaption>
			</figure>`,
			pic_left: `<figure class="articleFigure articleFigure--left">
				<img src="${this.state.pic_left.url}" alt="${this.state.pic_left.caption}" />
				<figcaption>${this.state.pic_left.caption}</figcaption>
			</figure>`,
			pic_right: `<figure class="articleFigure articleFigure--right">
				<img src="${this.state.pic_right.url}" alt="${this.state.pic_right.caption}" />
				<figcaption>${this.state.pic_right.caption}</figcaption>
			</figure>`,
			pic_big: `<figure class="articleFigure articleFigure--bigWidth ${this.state.pic_big.spoiler ? 'articleFigure--spoiler' : ''}">
				<img src="${this.state.pic_big.url}" alt="${this.state.pic_big.caption}" />
				<figcaption>${this.state.pic_big.caption}</figcaption>
			</figure>`,
			pic_full: `<figure class="articleFigure articleFigure--fullWidth ${this.state.pic_full.spoiler ? 'articleFigure--spoiler' : ''}">
				<img src="${this.state.pic_full.url}" alt="${this.state.pic_full.caption}" />
				<figcaption>${this.state.pic_full.caption}</figcaption>
			</figure>`,
			quote_left: `<figure class="articleQuote articleQuote--left">
				<h5>${this.state.quote_left.title}</h5>
				<div class="articleQuote__text">${this.state.quote_left.text}</div>
				<h6>${this.state.quote_left.footer}</h6>
			</figure>`,
			quote_right: `<figure class="articleQuote articleQuote--right">
				<h5>${this.state.quote_right.title}</h5>
				<div class="articleQuote__text">${this.state.quote_right.text}</div>
				<h6>${this.state.quote_right.footer}</h6>
			</figure>`,
			direct_quote: `<figure class="directQuote directQuote--photo">
				<div class="directQuote__authorInfo">
					<img src="${this.state.direct_quote.photo}" class="directQuote__photo">
					<h6>${this.state.direct_quote.author}</h6>
				</div>
				<div class="directQuote__content">
					<h5>${this.state.direct_quote.title}</h5>
					<span class="directQuote__text">${this.state.direct_quote.text}</span></div>
			</figure>`,
			quote: `<figure class="directQuote directQuote--quotes">
				<div class="directQuote__content">
					<h5>${this.state.quote.title}</h5>
					<span class="directQuote__text">${this.state.quote.text}</span>
					<h6>${this.state.quote.author}</h6>
				</div>
			</figure>`,
			similar_article: `<div class="articleCard articleCard--inline">
				<div class="articleCard__uptitle">${this.state.similar_article.subtitle}</div>
				<article>
					<div class="articleCard__image">
						<img src="${this.state.similar_article.img_url}" width="300px" height="180px" alt="">
					</div>
					<div class="articleCard__content">
						<h3 class="articleCard__title">
							<a href="${this.state.similar_article.url}" target="_blank" class="articleCard__titleLink">${this.state.similar_article.title}</a>
						</h3>
						<div class="articleCard__annotation"><p>${this.state.similar_article.description}</p></div>
					</div>
				</article>
			</div>`,
			articles_navigate: `<div class="navBetweenArticles">
				<article class="articleCard articleCard--inline ${(!this.state.articles_navigate.title1 || !this.state.articles_navigate.url1) && 'articleCard--invisible' || ''}">
					<div class="articleCard__content">
						<h3 class="articleCard__title"><a href="${this.state.articles_navigate.url1}">${this.state.articles_navigate.title1}</a></h3>
						<div class="articleCard__annotation"><p>${this.state.articles_navigate.description1}</p></div>
					</div>
				</article>
				<article class="articleCard articleCard--inline ${(!this.state.articles_navigate.title2 || !this.state.articles_navigate.url2) && 'articleCard--invisible' || ''}">
					<div class="articleCard__content">
						<h3 class="articleCard__title"><a href="${this.state.articles_navigate.url2}">${this.state.articles_navigate.title2}</a></h3>
						<div class="articleCard__annotation"><p>${this.state.articles_navigate.description2}</p></div>
					</div>
				</article>
			</div>`
		}
		const html = this.templates[params.type];

		newState[params.type].html = html;
		this.setState(newState);
	}

	render() {
		return (
			<div className="App">

				<div className="block">
					<h2>Картинка на поле слева</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.pic_left.style} className="articleFigure articleFigure--left">
								<img src={this.state.pic_left.url} alt={this.state.pic_left.caption} />
								<figcaption>{this.state.pic_left.caption}</figcaption>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="pic_left" rows="3" value={this.state.pic_left.html} />
							<button data-clipboard-target="#pic_left" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.pic_left.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>URL картинки</label>
							<input type="text" value={this.state.pic_left.url} onChange={this.handleChange.bind(this, {type: 'pic_left', field: 'url'})} />
							<label>Описание картинки</label>
							<input type="text" value={this.state.pic_left.caption} onChange={this.handleChange.bind(this, {type: 'pic_left', field: 'caption'})} />
						</div>
					</div>
				</div>
<hr />
				<div className="block">
					<h2>Картинка на поле справа</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.pic_right.style} className="articleFigure articleFigure--right">
								<img src={this.state.pic_right.url} alt={this.state.pic_right.caption} />
								<figcaption>{this.state.pic_right.caption}</figcaption>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="pic_right" rows="3" value={this.state.pic_right.html} />
							<button data-clipboard-target="#pic_right" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.pic_right.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>URL картинки</label>
							<input type="text" value={this.state.pic_right.url} onChange={this.handleChange.bind(this, {type: 'pic_right', field: 'url'})} />
							<label>Описание картинки</label>
							<input type="text" value={this.state.pic_right.caption} onChange={this.handleChange.bind(this, {type: 'pic_right', field: 'caption'})} />
						</div>
					</div>
				</div>
<hr />
				<div className="block">
					<h2>Картинка в ширину колонки текста</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.pic_regular.style} className="articleFigure {this.state.pic_regular.spoiler ? 'articleFigure--spoiler' : ''}">
								<img src={this.state.pic_regular.url} alt={this.state.pic_regular.caption} />
								<figcaption style={{paddingLeft: 0}}>{this.state.pic_regular.caption}</figcaption>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="pic_regular" rows="3" value={this.state.pic_regular.html} />
							<button data-clipboard-target="#pic_regular" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.pic_regular.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<input type="checkbox" id="spoiler_regular" value={this.state.pic_regular.spoiler} onChange={this.handleChange.bind(this, {type: 'pic_regular', field: 'spoiler'})} />
							<label htmlFor="spoiler_regular"> Скрыть под спойлером</label>

							<label>URL картинки</label>
							<input type="text" value={this.state.pic_regular.url} onChange={this.handleChange.bind(this, {type: 'pic_regular', field: 'url'})} />
							<label>Описание картинки</label>
							<input type="text" value={this.state.pic_regular.caption} onChange={this.handleChange.bind(this, {type: 'pic_regular', field: 'caption'})} />
						</div>
					</div>
				</div>
<hr />
				<div className="block">
					<h2>Картинка чуть шире колонки текста</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.pic_big.style} className="articleFigure articleFigure--bigWidth {this.state.pic_full.spoiler ? 'articleFigure--spoiler' : ''}">
								<img src={this.state.pic_big.url} alt={this.state.pic_big.caption} />
								<figcaption style={{paddingLeft: 0}}>{this.state.pic_big.caption}</figcaption>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="pic_big" rows="3" value={this.state.pic_big.html} />
							<button data-clipboard-target="#pic_big" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.pic_big.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<input type="checkbox" id="spoiler_big" value={this.state.pic_big.spoiler} onChange={this.handleChange.bind(this, {type: 'pic_big', field: 'spoiler'})} />
							<label htmlFor="spoiler_big"> Скрыть под спойлером</label>
							<label>URL картинки</label>
							<input type="text" value={this.state.pic_big.url} onChange={this.handleChange.bind(this, {type: 'pic_big', field: 'url'})} />
							<label>Описание картинки</label>
							<input type="text" value={this.state.pic_big.caption} onChange={this.handleChange.bind(this, {type: 'pic_big', field: 'caption'})} />
						</div>
					</div>
				</div>
<hr />
				<div className="block">
					<h2>Картинка на всю ширину сайта</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.pic_full.style} className="articleFigure articleFigure--fullWidth {this.state.pic_full.spoiler ? 'articleFigure--spoiler' : ''}">
								<img src={this.state.pic_full.url} alt={this.state.pic_full.caption} />
								<figcaption style={{paddingLeft: 0}}>{this.state.pic_full.caption}</figcaption>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="pic_full" rows="3" value={this.state.pic_full.html} />
							<button data-clipboard-target="#pic_full" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.pic_full.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<input type="checkbox" id="spoiler_full" value={this.state.pic_full.spoiler} onChange={this.handleChange.bind(this, {type: 'pic_full', field: 'spoiler'})} />
							<label htmlFor="spoiler_full"> Скрыть под спойлером</label>
							<label>URL картинки</label>
							<input type="text" value={this.state.pic_full.url} onChange={this.handleChange.bind(this, {type: 'pic_full', field: 'url'})} />
							<label>Описание картинки</label>
							<input type="text" value={this.state.pic_full.caption} onChange={this.handleChange.bind(this, {type: 'pic_full', field: 'caption'})} />
						</div>
					</div>
				</div>





<hr />
				<div className="block">
					<h2>Сноска слева</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.quote_left.style} className="articleQuote articleQuote--left">
								<h5>{this.state.quote_left.title}</h5>
								<div className="articleQuote__text" dangerouslySetInnerHTML={{__html: this.state.quote_left.text}}></div>
								<h6>{this.state.quote_left.footer}</h6>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="quote_left" rows="3" value={this.state.quote_left.html} />
							<button data-clipboard-target="#quote_left" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.quote_left.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>Заголовок</label>
							<input type="text" value={this.state.quote_left.title} onChange={this.handleChange.bind(this, {type: 'quote_left', field: 'title'})} />
							<label>Текст</label>
							<textarea rows="3" value={this.state.quote_left.text} onChange={this.handleChange.bind(this, {type: 'quote_left', field: 'text'})} />
							<label>Подпись</label>
							<input type="text" value={this.state.quote_left.footer} onChange={this.handleChange.bind(this, {type: 'quote_left', field: 'footer'})} />
						</div>
					</div>
				</div>
<hr />
				<div className="block">
					<h2>Сноска справа</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.quote_right.style} className="articleQuote articleQuote--right">
								<h5>{this.state.quote_right.title}</h5>
								<div className="articleQuote__text" dangerouslySetInnerHTML={{__html: this.state.quote_right.text}}></div>
								<h6>{this.state.quote_right.footer}</h6>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="quote_right" rows="3" value={this.state.quote_right.html} />
							<button data-clipboard-target="#quote_right" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.quote_right.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>Заголовок</label>
							<input type="text" value={this.state.quote_right.title} onChange={this.handleChange.bind(this, {type: 'quote_right', field: 'title'})} />
							<label>Текст</label>
							<textarea rows="3" value={this.state.quote_right.text} onChange={this.handleChange.bind(this, {type: 'quote_right', field: 'text'})} />
							<label>Подпись</label>
							<input type="text" value={this.state.quote_right.footer} onChange={this.handleChange.bind(this, {type: 'quote_right', field: 'footer'})} />
						</div>
					</div>
				</div>




<hr />
				<div className="block">
					<h2>Цитата с фотографией</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.direct_quote.style} className="directQuote directQuote--photo">
								<div className="directQuote__authorInfo">
									<img src={this.state.direct_quote.photo} className="directQuote__photo" />
									<h6>{this.state.direct_quote.author}</h6>
								</div>
								<div className="directQuote__content">
									<h5>{this.state.direct_quote.title}</h5>
									<span className="articleQuote__text" dangerouslySetInnerHTML={{__html: this.state.direct_quote.text}}></span>
								</div>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="direct_quote" rows="3" value={this.state.direct_quote.html} />
							<button data-clipboard-target="#direct_quote" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.direct_quote.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>Автор цитаты</label>
							<input type="text" value={this.state.direct_quote.author} onChange={this.handleChange.bind(this, {type: 'direct_quote', field: 'author'})} />
							<label>URL фотографии</label>
							<input type="text" value={this.state.direct_quote.photo} onChange={this.handleChange.bind(this, {type: 'direct_quote', field: 'photo'})} />
							<label>Заголовок</label>
							<input type="text" value={this.state.direct_quote.title} onChange={this.handleChange.bind(this, {type: 'direct_quote', field: 'title'})} />
							<label>Текст</label>
							<textarea rows="3" value={this.state.direct_quote.text} onChange={this.handleChange.bind(this, {type: 'direct_quote', field: 'text'})} />
						</div>
					</div>
				</div>
<hr />
				<div className="block">
					<h2>Цитата</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<figure style={this.state.quote.style} className="directQuote directQuote--quotes">
								<div className="directQuote__content">
									<h5>{this.state.quote.title}</h5>
									<span className="articleQuote__text" dangerouslySetInnerHTML={{__html: this.state.quote.text}}></span>
									<h6>{this.state.quote.author}</h6>
								</div>
							</figure>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="quote" rows="3" value={this.state.quote.html} />
							<button data-clipboard-target="#quote" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.quote.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>Автор цитаты</label>
							<input type="text" value={this.state.quote.author} onChange={this.handleChange.bind(this, {type: 'quote', field: 'author'})} />
							<label>Заголовок</label>
							<input type="text" value={this.state.quote.title} onChange={this.handleChange.bind(this, {type: 'quote', field: 'title'})} />
							<label>Текст</label>
							<textarea rows="3" value={this.state.quote.text} onChange={this.handleChange.bind(this, {type: 'quote', field: 'text'})} />
						</div>
					</div>
				</div>

				<hr />
				<div className="block">
					<h2>Блок "Читайте также"</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<div className="articleCard articleCard--inline">
								<div className="articleCard__uptitle">{this.state.similar_article.subtitle}</div>
								<article>
									<div className="articleCard__image">
										<img src={this.state.similar_article.img_url} width="300px" height="180px" alt="" />
									</div>
									<div className="articleCard__content">
										<a href="${this.state.similar_article.url}" className="articleCard__titleLink">
											<h3 className="articleCard__title">{this.state.similar_article.title}</h3>
										</a>
										<div className="articleCard__annotation"><p>{this.state.similar_article.description}</p></div>
									</div>
								</article>
							</div>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="similar_article" rows="3" value={this.state.similar_article.html} />
							<button data-clipboard-target="#similar_article" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.similar_article.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<label>Заголовок блока</label>
							<input type="text" value={this.state.similar_article.subtitle} onChange={this.handleChange.bind(this, {type: 'similar_article', field: 'subtitle'})} />
							<label>URL на статью</label>
							<input type="text" value={this.state.similar_article.url} onChange={this.handleChange.bind(this, {type: 'similar_article', field: 'url'})} />
							<label>URL на изображение</label>
							<input type="text" value={this.state.similar_article.img_url} onChange={this.handleChange.bind(this, {type: 'similar_article', field: 'img_url'})} />
							<label>Заголовок</label>
							<input type="text" value={this.state.similar_article.title} onChange={this.handleChange.bind(this, {type: 'similar_article', field: 'title'})} />
							<label>Описание</label>
							<textarea rows="3" value={this.state.similar_article.description} onChange={this.handleChange.bind(this, {type: 'similar_article', field: 'description'})} />
						</div>
					</div>
				</div>



				<hr />
				<div className="block">
					<h2>Блок навигации по другим частям материала</h2>
					<div className="blockWrapper">
						<div className="blockPreview">
							<h6>Превью</h6>
							<div className="navBetweenArticles">
								<article className="articleCard articleCard--inline {(!this.state.articles_navigate.title1 || !this.state.articles_navigate.url1) && 'articleCard--invisible' || ''}">
									<div className="articleCard__content">
										<h3 className="articleCard__title"><a href={this.state.articles_navigate.url1}>{this.state.articles_navigate.title1}</a></h3>
										<div className="articleCard__annotation"><p>{this.state.articles_navigate.description1}</p></div>
									</div>
								</article>
								<article className="articleCard articleCard--inline {(!this.state.articles_navigate.title1 || !this.state.articles_navigate.url1) && 'articleCard--invisible' || ''}">
									<div className="articleCard__content">
										<h3 className="articleCard__title"><a href={this.state.articles_navigate.url2}>{this.state.articles_navigate.title2}</a></h3>
										<div className="articleCard__annotation"><p>{this.state.articles_navigate.description2}</p></div>
									</div>
								</article>
								</div>
						</div>
						<div className="blockInputs">
							<h6>Код для вставки</h6>
							<textarea readOnly id="articles_navigate" rows="3" value={this.state.articles_navigate.html} />
							<button data-clipboard-target="#articles_navigate" type="button" className="button button--sm" onClick={this.copyToClipboard.bind(this, this.state.articles_navigate.html)}>Скопировать в буфер</button>
						</div>
						<div className="blockInputs">
							<h6>Параметры</h6>
							<div><small>Предыдущая часть</small></div>
							<label>URL на статью</label>
							<input type="text" value={this.state.articles_navigate.url1} onChange={this.handleChange.bind(this, {type: 'articles_navigate', field: 'url1'})} />
							<label>Заголовок</label>
							<input type="text" value={this.state.articles_navigate.title1} onChange={this.handleChange.bind(this, {type: 'articles_navigate', field: 'title1'})} />
							<label>Описание</label>
							<input type="text" value={this.state.articles_navigate.description1} onChange={this.handleChange.bind(this, {type: 'articles_navigate', field: 'description1'})} />

							<div><small>Предыдущая часть</small></div>
							<label>URL на статью</label>
							<input type="text" value={this.state.articles_navigate.url2} onChange={this.handleChange.bind(this, {type: 'articles_navigate', field: 'url2'})} />
							<label>Заголовок</label>
							<input type="text" value={this.state.articles_navigate.title2} onChange={this.handleChange.bind(this, {type: 'articles_navigate', field: 'title2'})} />
							<label>Описание</label>
							<input type="text" value={this.state.articles_navigate.description2} onChange={this.handleChange.bind(this, {type: 'articles_navigate', field: 'description2'})} />
						</div>
					</div>
				</div>




			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js